import { formatMoneyAmount } from './locale';

/** @deprecated Prefer useLocale().formatMoney for live currency conversion */
export function formatPrice(price, currencyCode = 'USD') {
  return formatMoneyAmount(price, currencyCode);
}
